//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  methods: {
    redirect: function redirect(href) {
      if (href) {
        this.openUrl(href);
      } else {
        this.toast('还未定档哦，微信关注“腾讯视频VIP”公众号，更多云首发内容早知道~');
      }
    }
  }
};